import Alpine from 'alpinejs';

Alpine.directive('datepicker', (element, {expression}, {cleanup, effect, evaluateLater}) => {
});
